import axiosInstance from '../libs/axiosInstance';

const createUserObject = (data) => ({
  first_name: data.first_name,
  last_name: data.last_name,
  email: data.email,
  password: data.password,
  gender: data.gender,
});

export const registerUser = async (data) => {
  try {
    const response = await axiosInstance.post('/account/create-account/', data);
    return response.data;
  } catch (error) {
    console.error('Registration failed:', error);
    throw error.response?.data || error.message;
  }
};

export const registerStudent = async (data) => {
  try {
    const response = await axiosInstance.post('/account/students/', data);
    return response.data;
  } catch (error) {
    console.error('Registration failed:', error);
    throw error.response?.data || error.message;
  }
};

export const registerLecturer = async (data) => {
  try {
    const response = await axiosInstance.post('/account/lecturers/', data);
    return response.data;
  } catch (error) {
    console.error('Registration failed:', error);
    throw error.response?.data || error.message;
  }
};

export const registerPreper = async (data) => {
    try {
      const response = await axiosInstance.post('/account/prepers/', {});
      return response.data;
    } catch (error) {
      console.error('Registration failed:', error);
      throw error.response?.data || error.message;
    }
  };
